import { render, staticRenderFns } from "./resaleCustomerInfo.pug?vue&type=template&id=338015a5&lang=pug&"
import script from "./resaleCustomerInfo.ts?vue&type=script&lang=ts&"
export * from "./resaleCustomerInfo.ts?vue&type=script&lang=ts&"
import style0 from "./resaleCustomerInfo.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports